import styled from 'styled-components';
import {
  CardActions as MuiCardActions,
  Typography,
  CardContent as MuiCardContent
} from '@mui/material';

export const Container = styled.div`
  width: 100%;
  padding: 10px;
  height: auto;
  overflow: auto;
  text-align: center !important;
`;

export const Col = styled.div`
  height: 170px;
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
  margin-bottom: 15px;
  .recharts-wrapper {
    cursor: pointer !important;
  }
`;

export const Link = styled(Typography)`
  background-color: rgba(0,0,0,.1);
  color: black !important ;
  font-weight: bold !important;
`;

export const Text = styled(Typography)`
  color: ${props => props.color};
`;

export const Scroller = styled(Typography)`
  display: block;
  padding-bottom: 10px;
`;

export const TextContainer = styled.div`
  width: 200px;
  white-space: 'nowrap';
`;

export const CardContent = styled(MuiCardContent)`
  padding: 0 !important;
`;

export const EmptyMessage = styled(Typography)`
  margin-top: 60px important;
  font-size: 0.9rem important;
`;

export const CardActions = styled(MuiCardActions)`
  background: #ddd;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 0;
`;

export const CardActionsWrapper = styled.div`
  text-align: center;
  width: 100%;
  padding: 0;
`;
